import Modal from '@/components/layout/Modal.vue'
import {CompanyTypeList, CompanyType,LinkList} from '@/helpers/utilities.js'
import {GetCompanies, UpdateCompany, CreateCompany, GetCompanyTypes, GetOfficeList} from '@/actions/directoryActions.js'
import Pagination from '@/components/layout/Pagination.vue'
import Loader from '@/components/layout/Loader.vue'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'
import { normalizeDirectoryText, showDirectoryPageWithRecord } from '@/helpers/directoryPagination.js'
export default {
    name : 'Company',
    components : { Modal, Loader, Pagination },
    data () {
        return {
            officeList : [],
            isLoaded : false,
            companyList :{
                docs: [],
                totalPages : 0,
                totalDocs : 0
            },
            searchParams : {
                search : '',
                page : 1,
            },
            newCompanyData : {},
            isAddNewClicked : false,
            isSaving :false,
            updateCompanyData : {},
            isUpdateClicked : false,
            CompanyTypeList : CompanyTypeList.slice(1),
            companyTypesData : [],
            CompanyType : CompanyType,
            ShowDetails : false,
            highlightedCompanyId : '',
            timer : null
        }
    },
    mounted : async function(){
        this.ReloadData()
        this.companyTypesData = await GetCompanyTypes()
        this.officeList = await GetOfficeList()
        this.$store.commit('setActiveLink',LinkList.MAIN_COMPANY)
    },  
    methods : {
        timerSetter(callback){
            const self = this
            
            if(self.timer){
                clearTimeout(self.timer)
                self.timer = null
            }

            self.timer = setTimeout(callback,700)
        },
        ReloadData(){
            const self = this
            self.isLoaded = false

            return GetCompanies(this.searchParams).then((res)=>{
                self.isLoaded = true
                self.companyList = res
                return res
            })
        },
        GetCompanyTypeName(companyType){
            const companyTypeId = Number(companyType)
            const companyTypeMatch = CompanyTypeList.find((type)=>type.id === companyTypeId)

            return companyTypeMatch?.value || '-'
        },
        GetCompanyTypeDisplayName(companyType){
            const companyTypeName = this.GetCompanyTypeName(companyType)

            return companyTypeName === '-' ? '-' : this.$t(companyTypeName)
        },
        FindCompanyRecord(list, matches){
            return Array.isArray(list?.docs)
                ? list.docs.find(matches)
                : null
        },
        CompanyRecordMatches({ id = '', companyName = '' } = {}){
            const normalizedName = normalizeDirectoryText(companyName)

            return (company) => {
                return (id && company._id === id) ||
                    (normalizedName && normalizeDirectoryText(company.companyName) === normalizedName)
            }
        },
        async ShowCompanyRecord({ id = '', companyName = '', search = '' } = {}){
            const matches = this.CompanyRecordMatches({ id, companyName })

            const loadMatchingPage = async (searchValue) => {
                this.searchParams.search = searchValue
                this.searchParams.page = 1
                const firstPage = await this.ReloadData()
                const pageData = await showDirectoryPageWithRecord({
                    firstPage,
                    loadPage: (page) => {
                        this.searchParams.search = searchValue
                        this.searchParams.page = page
                        return this.ReloadData()
                    },
                    matches
                })
                const matchedCompany = this.FindCompanyRecord(pageData, matches)

                if(matchedCompany){
                    this.highlightedCompanyId = matchedCompany._id
                    return true
                }

                return false
            }

            this.highlightedCompanyId = ''

            if(await loadMatchingPage(search || '')){
                return
            }

            if(search){
                await loadMatchingPage('')
            }
        },
        ClearCompanyHighlight(){
            this.highlightedCompanyId = ''
        },
        SearchCompany(){
            const self = this
            self.ClearCompanyHighlight()
            self.timerSetter(function(){
                self.ReloadData()

            })
        },
        ChangePage(page){
            this.ClearCompanyHighlight()
            this.searchParams.page = page
            this.ReloadData()
        },
        OpenCompanyModal() {
            this.newCompanyData = {
                mainTrade : '',
                companyType : '',
                officeId : ''
            }
        },
        CreateCompany(){
            const self = this
            const data = self.newCompanyData
            const createdCompanyName = normalizeDirectoryText(data.companyName)

            self.isAddNewClicked = true
            if(!data.companyName || !data.address || !data.companyType || !data.officeId){
                return
            }

            self.isAddNewClicked = false
            self.isSaving = true
            showDirectoryLoading(self, {
                title: 'Creating Company',
                description: 'Saving the company and updating the directory.'
            })
            CreateCompany(data).then((res)=>{
                self.isSaving = false
                if(res=='OK'){
                    self.$refs.closeAddModal.click()
                    self.ShowCompanyRecord({
                        companyName: createdCompanyName,
                        search: ''
                    }).catch(()=>{
                        return self.ReloadData()
                    }).then(()=>{
                        closeDirectoryLoading(self)
                        showDirectorySuccess(self, {
                            description: 'The company has been created successfully and added to the directory.'
                        })
                    })
                }else{
                    closeDirectoryLoading(self)
                    showDirectoryError(self, {
                        description: res,
                        duplicateValue: data.companyName
                    })
                }
            }).catch((error)=>{
                self.isSaving = false
                closeDirectoryLoading(self)
                showDirectoryError(self, {
                    description: error?.message || 'Unable to create company. Please try again.',
                    duplicateValue: data.companyName
                })
            })
        },
        OpenUpdateCompanyModal(data) {
            this.updateCompanyData = JSON.parse(JSON.stringify(data))

            this.updateCompanyData.mainTrade = this.updateCompanyData.mainTrade  || ''
        },
        UpdateCompany(e){
            const self = this
            const btn = e.target
            const data = self.updateCompanyData

            self.isUpdateClicked = true
            if(!data.companyName || !data.companyType || !data.officeId){
                return
            }
            self.isUpdateClicked = false

            btn.disabled = true
            self.isSaving = true
            showDirectoryLoading(self, {
                title: 'Updating Company',
                description: 'Saving the company changes and updating the directory.'
            })
            UpdateCompany(data).then((res)=>{
                self.isSaving = false
                btn.disabled = false
                if(res=='OK'){
                    self.$refs.closeUpdateModal.click()
                    self.ShowCompanyRecord({
                        id: data._id,
                        companyName: data.companyName,
                        search: self.searchParams.search || ''
                    }).catch(()=>{
                        return self.ReloadData()
                    }).then(()=>{
                        closeDirectoryLoading(self)
                        showDirectorySuccess(self, {
                            description: 'The company details have been updated successfully.'
                        })
                    })
                }else{
                    closeDirectoryLoading(self)
                    showDirectoryError(self, {
                        description: res,
                        duplicateValue: data.companyName
                    })
                }
            }).catch((error)=>{
                self.isSaving = false
                btn.disabled = false
                closeDirectoryLoading(self)
                showDirectoryError(self, {
                    description: error?.message || 'Unable to update company. Please try again.',
                    duplicateValue: data.companyName
                })
            })
        },
    }
}
